
import { Heading } from '@lmig/lmds-react-typography';
import './LinkBox.scss';
interface ILinkBox {
    title: string;
    icon: string;
    links: INavigationLink[];
}
const LinkBox = ({ title, icon, links }: ILinkBox) => {

    return links && links.length > 0 ? (
            <div className="lm-linkbox-wrapper">
                <div className="lm-linkbox-titleContainer">
                    {icon && <div className="lm-linkbox-iconContainer">
                        <div className="lm-IconWrapper">
                            <img className="lm-linkbox-titleContainer-icon" src={icon} alt="" aria-hidden="true" />
                        </div>
                    </div>}
                    <Heading type="h4-light" className="lm-linkbox-title">{title}</Heading>
                </div>
                {links.map((link, index) => (
                    <div className="lm-linkbox-linkwrapper" key={index}>
                        <a href={link.Link.Url} target={link.Link.Target} className="lm-Link lm-LinkNavigational">{link.Link.Text}</a>
                    </div>
                ))}
            </div>
    ) : <></>;
};

export default LinkBox;
